<template>
  <div>
    <a-card style="border: none; border-radius: 12px; margin-bottom: 20px">
      <a-form layout="inline">
        <a-form-item label="方案名称">
          <a-input v-model="dataForm.name" placeholder="请输入方案名称">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary"> 搜索 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="dataForm.name = ''"> 重置 </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none; border-radius: 12px" title="培训方案">
      <div slot="extra">
        <a-button
          icon="plus"
          @click="addorupdate()"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['train:trainProgram:add']"
        >
          新建培训方案
        </a-button>
      </div>
      <a-table
        filterMultiple
        rowKey="id"
        :columns="columns"
        :data-source="dataList"
        :pagination="false"
        :loading="dataListLoading"
        :scroll="{ x: 1500 }"
      >
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button
              size="small"
              type="link"
              @click="addorupdate(record.id, 1)"
              v-permission="['train:trainProgram:page']"
              >查看
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="addorupdate(record.id, 0)"
              v-permission="['train:trainProgram:edit']"
              >编辑
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="deleteHandle(record.id)"
              v-permission="['train:trainProgram:delete']"
              >删除</a-button
            >
          </a-space>
        </span>
        <span slot="create_time" slot-scope="text">
          {{ moment(text).format("YYYY-MM-DD") }}
        </span>
      </a-table>
      <a-pagination
        style="margin-top: 20px; float: right"
        show-size-changer
        :current="page"
        show-quick-jumper
        :total="total"
        @showSizeChange="showSizeChange"
        @change="pageCurrentChangeHandle"
        :show-total="(total) => `共 ${total} 条`"
      />
    </a-card>
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import { formatSeconds } from "@/utils/util";
export default {
  mixins: [viewModule],
  data() {
    return {
      dataForm: {
        name: "",
      },
      columns: [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 80,
          align: "center",
          customRender: (text, record, index) => {
            return (this.page - 1) * this.limit + index + 1;
          },
        },
        {
          title: "方案名称",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 200,
        },
        {
          title: "培训负责人",
          dataIndex: "principal",
          key: "principal",
          align: "center",
        },
        {
          title: "课程节数",
          dataIndex: "classes",
          key: "classes",
          align: "center",
          customRender: (text) => {
            return text ? text.split(",").length : 0;
          },
        },
        {
          title: "题库数",
          dataIndex: "topics",
          key: "topics",
          align: "center",
          customRender: (text) => {
            return text ? text.split(",").length : 0;
          },
        },
        // {
        //   title: "时长",
        //   dataIndex: "classes_time",
        //   key: "classes_time",
        //   align: "center",
        //   customRender: (text) => {
        //     return formatSeconds(text);
        //   },
        // },
        {
          title: "课时",
          dataIndex: "classes",
          key: "classes",
          align: "center",
          customRender: (text) => {
            return text ? text.split(",").length + "课时" : "0课时";
          },
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: "/trainProgram/page",
        deleteURL: "/trainProgram/delete",
      },
      dataForm: {
        name: "",
      },
    };
  },
  methods: {
    addorupdate(id = "", readonly = 0) {
      this.$router.push({
        path: "/train/trainProgramAddOrUpdate",
        query: { id: id, readonly: readonly },
      });
    },
  },
};
</script>

<style>
</style>